"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.staticEmbedBlockquote = void 0;
const staticEmbedBlockquote = ({ width, height, embedSrc, style, contentUrl, title, }) => {
    // Readable markup:
    const markup = `
<blockquote
	class="snapchat-embed"
	data-snapchat-embed-width="${width}"
	data-snapchat-embed-height="${height}"
	data-snapchat-embed-url="${embedSrc}"
	data-snapchat-embed-style="${style}"
	data-snapchat-embed-title="${title}"
	style="background:#C4C4C4; border:0; border-radius:40px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:416px; min-width:326px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px); display: flex; flex-direction: column; position: relative; height:650px;">
	<div style="display: flex; flex-direction: row; align-items: center;">
		<a title="${title}" href="${contentUrl}" style="background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; width: 40px; margin:16px; cursor: pointer"></a>
		<div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center;"></div>
	</div>
	<div style="flex: 1;"></div>
	<div style="display: flex; flex-direction: row; align-items: center; border-end-end-radius: 40px; border-end-start-radius: 40px;">
		<a title="${title}" href="${contentUrl}" style="background-color: yellow; width:100%; padding: 10px 20px; border: none; border-radius: inherit; cursor: pointer; text-align: center; display: flex;flex-direction: row;justify-content: center; text-decoration: none; color: black;">
		View more on Snapchat
		</a>
	</div>
</blockquote>
<script async src="https://www.snapchat.com/embed.js"></script>
`;
    // Return as a single line:
    return markup.replace(/\t/gm, " \n").replace(/(\r\n|\n|\r)/gm, "");
};
exports.staticEmbedBlockquote = staticEmbedBlockquote;
//# sourceMappingURL=EmbedStaticCode.js.map